module.exports = __webpack_public_path__ + "img/2.61f63542.png";